import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { compose } from 'ramda';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider } from 'components';
import { codelists } from 'constants/codelists';
import { getTaskIds } from 'features/views/taskForwarding/selectors';

import TasksTableRow from './TasksTableRow';

export const TasksTable = ({ taskTypesCodelist, taskSubtypesCodelist }) => {
	const taskIds = useSelector(getTaskIds);
	const showDeleteButton = taskIds.length > 1;

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>{getLabelMessage('taskForwarding:taskId')}</TableCell>
					<TableCell>
						<div>{getLabelMessage('taskForwarding:taskType')} </div>
						<div>{getLabelMessage('taskForwarding:subType')} </div>
					</TableCell>
					<TableCell>{getLabelMessage('taskForwarding:deadline')}</TableCell>
					<TableCell>{getLabelMessage('taskForwarding:psNumber')}</TableCell>
					<TableCell>{getLabelMessage('taskForwarding:clientName')}</TableCell>
					{showDeleteButton && <TableCell />}
				</TableRow>
			</TableHead>
			<TableBody>
				{taskIds.map((id) => (
					<TasksTableRow
						key={id}
						taskId={id}
						showDeleteButton={showDeleteButton}
						taskTypesCodelist={taskTypesCodelist}
						taskSubtypesCodelist={taskSubtypesCodelist}
					/>
				))}
			</TableBody>
		</Table>
	);
};

TasksTable.propTypes = {
	taskSubtypesCodelist: PropTypes.array,
	taskTypesCodelist: PropTypes.array,
};

export default compose(
	codelistProvider(codelists.taskTypes, 'taskTypesCodelist'),
	codelistProvider(codelists.taskSubtypes, 'taskSubtypesCodelist'),
)(TasksTable);
